const formatEducationInfo = educationInfo => {
  if (!educationInfo) return "";

  // String bo'lsa to'g'ridan-to'g'ri qaytaramiz
  if (typeof educationInfo === "string") {
    return educationInfo;
  }

  const fields = [
    { label: "OTM nomi:", value: educationInfo.institutionName || educationInfo.institution_name },
    { label: "Boshlanish sanasi:", value: educationInfo.startDate || educationInfo.edu_starting_date },
    { label: "Tugash sanasi:", value: educationInfo.endDate || educationInfo.edu_finishing_date },
    { label: "Diplom raqami:", value: educationInfo.diplomaNumber || educationInfo.diploma_number },
    { label: "Daraja:", value: educationInfo.degree || educationInfo.degree_name }
  ];

  return fields
    .filter(f => f.value)
    .map(f => `• ${f.label} <strong>${f.value}</strong>`)
    .join("<br>");
};

const formatPassportInfo = item => {
  const parts = [];

  if (item?.passportNumber) {
    parts.push(`Pasport: <strong>${item.passportNumber}</strong>`);
  }
  if (item?.passportGivenDate) {
    parts.push(`Berilgan sana: <strong>${item.passportGivenDate}</strong>`);
  }
  if (item?.passportEndDate) {
    parts.push(`Amal qilish muddati: <strong>${item.passportEndDate}</strong>`);
  }
  if (item?.passportGivenWho) {
    parts.push(`Kim tomonidan: <strong>${item.passportGivenWho}</strong>`);
  }

  return parts.join("<br>") || "";
};

const generateTableData = item => [
  {
    title: "Talabgor FIO:",
    value: `${item?.lastName || ""} ${item?.firstName || ""} ${item?.parentName || ""}`.trim()
  },
  { title: "Talabgor JSHSHIR:", value: item?.inps || item?.pnfl },
  { title: "Talabgor pasporti:", value: formatPassportInfo(item) },
  { title: "Talabgor tug'ilgan sanasi:", value: item?.birthday || item?.birthDate },
  { title: "Talabgor manzili:", value: item?.address || item?.regionNameLt || item?.regionNameUz },
  { title: "Talabgor telefoni:", value: item?.mobilePhone || item?.phone },
  { title: "Talabgor millati:", value: item?.nationality },
  { title: "Talabgor email:", value: item?.email },
  {
    title: "Talabgor oliy ma'lumot to'g'risida ma'lumoti:",
    value: formatEducationInfo(item?.educationInfo)
  },
  {
    title: "Talabgor narkologiya dispanserida hisobida turishi to'g'risida ma'lumot:",
    value: item?.narcologyInfo
  },
  {
    title: "Talabgor psixiatriya dispanserida hisobida turishi to'g'risida ma'lumot:",
    value: item?.psychiatryInfo
  },
  {
    title: "Talabgor sudlanmaganligi to'g'risida ma'lumot:",
    value: item?.criminalRecordInfo
  }
];

const generateWorkHistorySection = workHistory => {
  if (!workHistory || workHistory.length === 0) {
    return '<p style="text-align: center; color: #666; margin: 0;">Ma\'lumotlar topilmadi</p>';
  }

  return workHistory
    .map((work, index) => {
      const companyName = work?.company_name || work?.organization || "";
      const position = work?.position_name || work?.position || "";
      const startDate = work?.start_date || work?.startDate || "";
      const endDate = work?.end_date || work?.endDate || null;
      const department = work?.structure_name || work?.department || "";
      const address = work?.workplace_address || work?.companyAddress || "";
      const tin = work?.company_inn || work?.tin || "";
      const orderDate = work?.order_date || "";
      const orderNumber = work?.order_number || "";

      return `
        <div style="margin-bottom: 15px; padding-bottom: 10px; ${index < workHistory.length - 1 ? "border-bottom: 1px dashed #ccc;" : ""}">
          <p style="font-weight: bold; margin-bottom: 5px; font-size: 11pt;">
            ${index + 1}. ${companyName}
          </p>
          ${department ? `<p style="margin: 3px 0; font-size: 11pt;">Bo'limi: <strong>${department}</strong></p>` : ""}
          ${position ? `<p style="margin: 3px 0; font-size: 11pt;">Lavozimi: <strong>${position}</strong></p>` : ""}
          ${address ? `<p style="margin: 3px 0; font-size: 11pt;">Manzili: <strong>${address}</strong></p>` : ""}
          ${tin ? `<p style="margin: 3px 0; font-size: 11pt;">STIR: <strong>${tin}</strong></p>` : ""}
          ${orderDate ? `<p style="margin: 3px 0; font-size: 11pt;">Buyruq sanasi: <strong>${orderDate}</strong></p>` : ""}
          ${orderNumber ? `<p style="margin: 3px 0; font-size: 11pt;">Buyruq raqami: <strong>${orderNumber}</strong></p>` : ""}
          ${startDate ? `<p style="margin: 3px 0; font-size: 11pt;">Boshlagan sanasi: <strong>${startDate}</strong></p>` : ""}
          <p style="margin: 3px 0; font-size: 11pt;">Tugagan sanasi: <strong>${endDate || "Hozirgi kungacha"}</strong></p>
        </div>
      `;
    })
    .join("");
};

const generateHtml = (item, base64Logo, base64Photo) => {
  const tableData = generateTableData(item);

  return `
    <html>
      <head>
        <meta charset="utf-8">
        <title>Advokatlikka talabgor</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: "Times New Roman", Times, serif !important; font-size: 11pt; }
          strong, b { font-weight: 900 !important; }
          @page { size: A4; margin: 2cm 1.5cm 2cm 2cm !important; }
        </style>
      </head>
      <body>
        <div style="padding: 15px;">
          <!-- Header with logo -->
          <table style="width: 100%; border: 2px solid #000; border-collapse: collapse;">
            <tr>
              <td style="width: 120px; padding: 15px; vertical-align: middle; border-right: 2px solid #000;">
                ${base64Logo ? `<img style="width: 100%; height: auto;" src="${base64Logo}" alt="Logo">` : ""}
              </td>
              <td style="padding: 15px; vertical-align: middle; text-align: center;">
                <p style="font-size: 13pt; font-weight: bold; line-height: 1.5; margin: 0;">
                  O'zbekiston Respublikasi Adliya vazirligi<br>
                  "Yuridik yordam" axborot tizimi
                </p>
              </td>
            </tr>
          </table>

          <!-- Title -->
          <h2 style="text-align: center; font-size: 13pt; font-weight: bold; margin-top: 25px; margin-bottom: 20px;">
            Advokatlikka talabgor to'g'risida ma'lumot
          </h2>

          <!-- Main content -->
          <table style="width: 100%; border-collapse: collapse; border: 1.5px solid #000;">
            <tr>
              <td style="width: 160px; vertical-align: top; border-right: 1.5px solid #000; border-bottom: 1.5px solid #000; padding: 5px;">
                <div style="width: 150px; height: 190px; display: flex; align-items: center; justify-content: center; background-color: #f5f5f5;">
                  ${base64Photo
                    ? `<img style="width: 100%; height: 100%; object-fit: cover;" src="${base64Photo}" alt="Rasm">`
                    : '<span style="text-align: center; font-size: 10pt; color: #999;">Rasm</span>'
                  }
                </div>
              </td>
              <td style="border-bottom: 1.5px solid #000; padding: 8px 10px; vertical-align: top; font-size: 11pt;">
                <strong>${tableData[0].title}</strong> ${tableData[0].value}
              </td>
            </tr>
            ${tableData.slice(1).map((row, index) => `
            <tr>
              <td style="padding: 8px 10px; ${index < tableData.length - 2 ? "border-bottom: 1.5px solid #000;" : ""} border-right: 1.5px solid #000; width: 38%; vertical-align: top; font-size: 11pt;">
                ${row.title}
              </td>
              <td style="padding: 8px 10px; ${index < tableData.length - 2 ? "border-bottom: 1.5px solid #000;" : ""} vertical-align: top; line-height: 1.5; font-size: 11pt;">
                ${row.value || ""}
              </td>
            </tr>
            `).join("")}
          </table>

          <!-- Work history section -->
          <table style="width: 100%; border-collapse: collapse; margin-top: 0;">
            <tr>
              <td colspan="2" style="border: 1px solid #000; border-top: none; padding: 8px 10px; font-size: 11pt; font-weight: bold;">
                Talabgor ish joylari bo'yicha ma'lumoti:
              </td>
            </tr>
          </table>
          <div style="border: 1px solid #000; border-top: none; padding: 10px; font-size: 11pt;">
            ${generateWorkHistorySection(item?.workHistory)}
          </div>
        </div>
      </body>
    </html>
  `;
};

export default {
  generateTableData,
  formatEducationInfo,
  formatPassportInfo,
  generateWorkHistorySection,
  generateHtml
};
